var exports = {
  "KP": "CommandRow__FZYaAo",
  "Yv": "CommandRowHeading__8Q-wKb",
  "Hv": "CommandRowBodyWrapper__kOvwao",
  "Uu": "CommandRowBody__eauOev",
  "jC": "CommandRowCopyButton__jaNrI9",
  "bL": "ProTip__RUZKCJ",
  "M3": "ProTipIcon__y3DYpU",
};

module.exports = exports;
